import React, {useContext} from 'react';
import {BrowserRouter, Route, Routes, Navigate, useParams} from 'react-router-dom';
import Detail from '../modules/Detail';
import Home from '../modules/Home/index';
import Checkout from "../modules/Checkout";
import ExperiencesDetail from "../modules/Experiences/Detail";
import ExperiencesCheckout from "../modules/Experiences/Checkout";
import CheckOutLayout from "../modules/Checkout/Layout/layout"
import ExperienceProvidersLayout from '../layouts/ExperienceProvidersLayout';

function RoutesComponent() {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/home" element={<Navigate to="/" />} />
        <Route exact path="/detail/:id" element={<Detail />} />
        <Route exact path="/trip/:id" element={<Detail />} />
        <Route exact path="/" element={<Home />} />
        <Route exact path="/:promoter" element={<Home />} />
        <Route path="/checkout/" element={<Navigate to="/"/>}/>
        <Route path="/checkout/*" element={<CheckOutLayout />}>
          <Route path="*" element={<Checkout/>}/>
        </Route>
        <Route path="/experiences/:id" element={<ExperienceProvidersLayout />}>
            <Route index element={<ExperiencesDetail />} />
            <Route path="/experiences/:id/checkout/*" element={<CheckOutLayout/>}>
              <Route path="*" element={<ExperiencesCheckout/>}/>
            </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default RoutesComponent;
